import React from 'react';
import PropTypes from 'prop-types';
import Component from 'BaseComponent';

export default class Spinner extends Component {
  static propTypes = {
    size: PropTypes.number.isRequired,
    inline: PropTypes.bool,
    reverse: PropTypes.bool,
    over: PropTypes.bool,
  }

  static defaultProps = {
    size: 40,
    inline: false,
  }

  render() {
    const { inline, reverse, over } = this.props;
    const className = ['Spinner'];

    if (inline) {
      className.push('Spinner--inline');
    } else if (over) {
      className.push('Spinner--over');
    } else {
      className.push('Spinner--centered');
    }

    if (reverse) {
      className.push('Spinner--reverse');
    }

    const bars = [];

    for (let i = 0; i < 12; i += 1) {
      const barStyle = {};
      barStyle.WebkitAnimationDelay = `${(i - 12) / 10}s`;
      barStyle.animationDelay = `${(i - 12) / 10}s`;

      barStyle.WebkitTransform = `rotate(${(i * 30)}deg) translate(146%)`;
      barStyle.transform = `rotate(${(i * 30)}deg) translate(146%)`;

      bars.push(<div style={barStyle} className="Spinner__bar" key={i} />);
    }

    const { size } = this.props;

    const style = {
      width: size * 0.5,
      height: size * 0.5,
    };

    if (inline) {
      style.marginLeft = size * 0.5;
      style.marginTop = size * 0.5;
    }

    if (over) {
      style.marginLeft = size * 0.25;
      style.marginTop = size * 0.25;
    }


    return (
      <div
        className={className.join(' ')}
        style={style}
      >
        {bars}
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./app/components/Spinner.jsx